import { Breadcrumb, ChartBarIcon, PageHero } from "@";
import Tabs from "../components/Tabs.tsx";
import { useStatisticsPage } from "../hooks";
import MultiSearch from "../components/MultiSearch.tsx";
import QualityStatistics from "../components/QualityStatistics.tsx";
import VerificationNumbers from "../components/VerificationNumbers.tsx";
import AssignmentStatistics from "../components/AssignmentStatistics.tsx";

const StatisticsPage = () => {
  const links = [{ name: "الإحصائيات", link: "" }];

  const {
    activeTab,
    handleTabChange,
    search,
    updateSearch,
    handleSearchSubmit,
    handleSearchReset,
    appliedFromDate,
    appliedToDate,
  } = useStatisticsPage();

  return (
    <>
      <Breadcrumb links={links} />

      <main className="table-card pb-4">
        <PageHero
          eyebrow="العمليات / الإحصائيات"
          title="إحصائيات التوثيق"
          icon={ChartBarIcon}
        />

        <MultiSearch
          search={search}
          onSubmit={handleSearchSubmit}
          updateSearch={updateSearch}
          onReset={handleSearchReset}
        />

        <Tabs activeTab={activeTab} handleTabChange={handleTabChange} />

        <div className="mt-2">
          {activeTab === "numbers" && (
            <VerificationNumbers
              fromDate={appliedFromDate}
              toDate={appliedToDate}
            />
          )}

          {activeTab === "assignment" && (
            <AssignmentStatistics
              fromDate={appliedFromDate}
              toDate={appliedToDate}
            />
          )}

          {activeTab === "quality" && (
            <QualityStatistics
              fromDate={appliedFromDate}
              toDate={appliedToDate}
            />
          )}
        </div>
      </main>
    </>
  );
};

export default StatisticsPage;
